export default "__VITE_ASSET__019b0339__"